<div class="manage-sidebar-header">
  <div class="manage-sidebar-header-close-btn" (click)="closeDrawer();">
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.7071 7.70711C16.0976 7.31658 16.0976 6.68342 15.7071 6.29289C15.3166 5.90237 14.6834 5.90237 14.2929 6.29289L11 9.58579L7.70711 6.29289C7.31658 5.90237 6.68342 5.90237 6.29289 6.29289C5.90237 6.68342 5.90237 7.31658 6.29289 7.70711L9.58579 11L6.29289 14.2929C5.90237 14.6834 5.90237 15.3166 6.29289 15.7071C6.68342 16.0976 7.31658 16.0976 7.70711 15.7071L11 12.4142L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L12.4142 11L15.7071 7.70711Z"
        fill="#3E3D67" />
    </svg>
  </div>
  <div class="manage-sidebar-header-text-position">
    <div class="manage-sidebar-header-text">Filters</div>
    @if (showDiv === 'addFirstFilter') {
    <div class="manage-sidebar-header-subtitle">Add filters to easily find and manage groups of orders</div>
    }
  </div>
  @if (showDiv === 'addFilter') {
  <img
    class="manage-side-bar__content-back-arrow"
    src="../../../../../assets/icons/delete-arrow.svg"
    (click)="goManage()"
    alt="" />
  } @if (showDiv === 'manage') {
  <div class="manage-filters__actions">
    <button class="manage-filters__actions__add-button" (click)="toggleAddSectionFromManage()">
      <span class="manage-filters__actions__add-button-icon">
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.5 8H9V5.5C9 5.22 8.78 5 8.5 5C8.22 5 8 5.22 8 5.5V8H5.5C5.22 8 5 8.22 5 8.5C5 8.78 5.22 9 5.5 9H8V11.5C8 11.78 8.22 12 8.5 12C8.78 12 9 11.78 9 11.5V9H11.5C11.78 9 12 8.78 12 8.5C12 8.22 11.78 8 11.5 8Z"
            fill="white" />
          <path
            d="M8.5 0C3.81 0 0 3.81 0 8.5C0 13.19 3.81 17 8.5 17C13.19 17 17 13.19 17 8.5C17 3.81 13.19 0 8.5 0ZM8.5 16C4.36 16 1 12.64 1 8.5C1 4.36 4.36 1 8.5 1C12.64 1 16 4.36 16 8.5C16 12.64 12.64 16 8.5 16Z"
            fill="white" />
        </svg>
      </span>
      <span class="manage-filters__actions__add-button-text"> Add filter</span>
    </button>
    @if (selectedActiveFilters?.length > 0) {
    <span class="manage-filters__actions__clearAll">
      <a (click)="clickResetSelected($event)">Deselect all</a>
    </span>
    }
  </div>
  }
</div>

@if (showDiv === 'addFirstFilter') {
<!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
<button
  class="manage-side-bar__new-add-filter"
  mat-stroked-button
  color="#4516B7"
  (click)="toggleAddSectionFromManage()">
  Add filter
</button>
} @if (showDiv === 'addFilter') {
<section class="manage-side-bar__content">
  <div class="manage-side-bar__content-addFilter-form">
    <form [formGroup]="advancedFiltersForm">
      <div class="manage-side-bar__content-addFilter-form">
        <span class="manage-side-bar__content-addFilter-form-filtername">New filter's name</span>
        <input
          class="filterNameInput"
          formControlName="filterName"
          matInput
          type="text"
          [(ngModel)]="filterName"
          placeholder="Enter name" />
        <div>
          <div class="rules-operator-container">
            <span>Filter orders that match</span>
            <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
            <mat-select
              [(ngModel)]="selectRule"
              formControlName="selectRule"
              panelClass="pdq-mat-select--panel"
              class="pdq-mat-select pdq-mat-select--default"
              #openOptions
              [disableOptionCentering]="true">
              @for (rulesType of rulesTypesOptions; track rulesType) {
              <mat-option [value]="rulesType.value"> {{ rulesType.text }} </mat-option>
              }
            </mat-select>
            <span class="manage-side-bar__content-addFilter-form-orders-match__text">of these rules:</span>
          </div>
          <div style="margin-top: 30px">Set filter's rules:</div>
          <div class="manage-side-bar__content-addFilter-form-select-rule">
            <div class="selectRule-panel">
              <pdq-dropdown
                class="filters-option-dropdown"
                variant="static"
                [options]="advancedFilterService.filterEntityOptions"
                (onChange)="entityChanged($event)"
                width="100"
                placeholder="Choose"
                [defaultOption]="getFilterEntityDefaultOption()">
              </pdq-dropdown>
            </div>
            @if (advancedFilterService.filterConditionOptions) {
            <div class="condition-panel">
              <pdq-dropdown
                class="filters-option-dropdown"
                variant="static"
                [options]="advancedFilterService.filterConditionOptions[advancedFiltersForm.value.filterEntity]"
                width="110"
                (onChange)="conditionChanged($event)"
                placeholder="Choose">
              </pdq-dropdown>
            </div>
            }
            <div class="input-value-wrapper">
              @if (!advancedFiltersForm.controls.conditionEntity.value) {
              <pdq-input class="value-param" placeholder="value" disabled="true"> </pdq-input>
              } @else { @for ( param of
              advancedFilterService.getParamsBySelectedCondition(advancedFiltersForm.controls.filterEntity.value,
              advancedFiltersForm.controls.conditionEntity.value); track param; let i = $index) {
              <div>
                <div class="value-param">
                  @switch (param.fieldType) { @case (inputType.NUMBER) {
                  <pdq-input-arrows min="0" precision="3" [formControlName]="'param1'" variant="form">
                  </pdq-input-arrows>
                  } @case (inputType.STRING) {
                  <div>
                    <div>
                      @switch (param.fieldSubType) { @case (inputSubType.AUTOCOMPLETE) {
                      <div class="autocomplete-wrapper">
                        <div class="autocomplete-multi-select-wrapper">
                          <div class="tags-container__list-options">
                            @if (advancedFiltersForm.controls['param1'].value?.length) { @for ( selectedTag of
                            advancedFiltersForm.controls['param1'].value; track selectedTag; let tagIndex = $index) {
                            <pdq-chip
                              #chipRef
                              [maxWidth]="maximumAutocompleteWidth"
                              [label]="selectedTag.label"
                              (onChange)="onAutocompleteResultRemove(selectedTag)">
                            </pdq-chip>
                            } }
                          </div>
                          <pdq-input
                            [formControlName]="'param2'"
                            placeholder=" "
                            [autofocus]="true"
                            [autocompleteMode]="true"
                            [autocompleteRef]="pdqAutocomplete"
                            [background]="'transparent'"
                            [autoCompleteWidth]="419"
                            [autoCompleteHeight]="112"
                            [offsetPositionX]="-100"
                            [border]="false">
                          </pdq-input>
                          <pdq-autocomplete #pdqAutocomplete="pdqAutocomplete" [mode]="'tags'">
                            <ng-template pdqAutocompleteContent>
                              @if (isLoadingResults) {
                              <ng-container class="is-loading">
                                <pdq-spinner></pdq-spinner>
                              </ng-container>
                              } @if (!isLoadingResults) { @for (tag of getAutocompleteMatchingResults(); track tag) {
                              <pdq-options (click)="onAutocompleteResultSelect(tag)" [value]="tag">
                                <pdq-tag
                                  #tagRef
                                  [matTooltip]="isTextOverflowed(tagRef) ? '' : getAutocompleteResultString(tag)"
                                  [matTooltipClass]="'tags-filter__tooltip'"
                                  [maxWidth]="maximumAutocompleteWidth"
                                  >{{ getAutocompleteResultString(tag) }}
                                </pdq-tag>
                              </pdq-options>
                              } @if (isMissingAutocompleteResults()) {
                              <div class="no-results-found">
                                <span class="no-results-found__title"
                                  >No results for "{{ getParameterControlValue(1) }}".
                                </span>
                                <span class="no-results-found__subtitle">Maybe try something else?</span>
                              </div>
                              } }
                            </ng-template>
                          </pdq-autocomplete>
                        </div>
                      </div>
                      } @case (inputSubType.FREE_TEXT) {
                      <div>
                        <pdq-input [formControlName]="'param1'" placeholder="value" [background]="'default'">
                        </pdq-input>
                      </div>
                      } @case (inputSubType.LIST) {
                      <div style="display: inline-block; max-width: 146px">
                        <pdq-dropdown
                          [options]="param.options"
                          (onChange)="
                                advancedFiltersForm.controls['param1'].setValue($event.value);
                                advancedFiltersForm.controls['param1'].markAsDirty()
                              "
                          placeholder="Choose">
                        </pdq-dropdown>
                      </div>
                      } }
                    </div>
                  </div>
                  } @case (inputType.COLOR) {
                  <pdq-color-tag-picker
                    variant="form"
                    [autoApply]="true"
                    formControlName="param1"
                    [shopColors]="(shop$ | async)?.colorCoding"></pdq-color-tag-picker>

                  } }
                </div>
              </div>
              } }
            </div>
            <button class="manage-side-bar__content-apply add-line" (click)="onAddLine()">
              <span>Apply</span>
            </button>
          </div>
        </div>
        <div class="manage-side-bar__content__divider"></div>
        @if (showError) {
        <div class="error-message">{{ errorMessage }}</div>
        }
        <div class="manage-side-bar__content-filters">
          @for (filter of advancedFiltersForm.value.filters ; track filter; let i = $index) {
          <div class="manage-side-bar__content-filters__row">
            <div class="manage-side-bar__content-filters__row-box box-size">
              <span class="manage-side-bar__content-filters__row-contents">
                {{ getFilterConditionEntityDisplay(filter['filterEntity']) }}
              </span>
            </div>
            <div class="manage-side-bar__content-filters__row-chip">
              <span class="manage-side-bar__content-filters__row-contents"> {{ filter['conditionEntity'] }} </span>
            </div>
            <div class="manage-side-bar__content-filters__row-box box-size">
              @if (filter?.filterEntity === filterEntities.COLOR_CODING) {
              <span class="colors-wrapper">
                @for (color of filter.value; track color; let i = $index) {
                <pdq-color-tag
                  class="manage-side-bar__content-filters__row-contents"
                  [color]="color"
                  [isLast]="i === filter.value.length - 1"></pdq-color-tag>
                }</span
              >
              } @if (filter?.filterEntity !== filterEntities.COLOR_CODING) {
              <span
                class="manage-side-bar__content-filters__row-contents"
                appOverflowText
                [overFlowText]="filterValueOutputString(filter)"
                [setMaxLength]="MAX_CHARS">
                {{ stringLengthConcat(filterValueOutputString(filter)) }}
              </span>
              }
            </div>
            <span>
              <button class="manage-side-bar__content-action-button remove-line" (click)="removeLine(i)">
                <img src="../../../../../assets/icons/cancel-X.svg" alt="" />
              </button>
            </span>
          </div>
          }
        </div>
        <div class="manage-side-bar__content-save-filter">
          <button
            mat-raised-button
            type="submit"
            class="manage-side-bar__content-save-filter-button"
            [disabled]="!filterName || !isFormValid"
            (click)="saveAdvancedFilter($event)">
            Save filter
          </button>
        </div>
      </div>
    </form>
  </div>
</section>
} @if (showDiv === 'manage') {
<div class="advanced-filters-manage-side">
  <div class="manage-filters__row">
    <mat-button-toggle-group
      cdkDropList
      (cdkDropListDropped)="drop($event)"
      (change)="onChangeFilter($event)"
      [(ngModel)]="selectedActiveFilters"
      [multiple]="true"
      (click)="$event.stopPropagation()"
      class="advanced-filters-manage__group">
      @for (advancedFilter of pinnedArray; track identify(i, advancedFilter); let i = $index) {
      <mat-button-toggle
        [cdkDragData]="advancedFilter"
        cdkDrag
        class="advanced-filters-manage__group-button"
        [value]="advancedFilter">
        <div class="filter-item">
          <div cdkDragHandle class="drag-wrapper">
            @for (i of [0, 1, 2, 3, 4, 5]; track $index) {
            <div class="drag-rectangle"></div>
            }
          </div>
          <button
            class="manage-filters__button-icon expand-icon"
            id="selected4"
            (click)="onExpandRow($event,advancedFilter.id, advancedFilter)">
            <img src="assets/icons/expand-arrow.svg" [ngClass]="{'rotate': showIndex === advancedFilter.id}" />
          </button>
          <span class="manage-filters__button-name">
            {{ advancedFilter.name }} @if (advancedFilter.resultCount) {
            <span>({{ advancedFilter.resultCount }})</span>
            }
          </span>
          <pdq-icon
            icon="delete"
            (click)="onDeleteFilter($event, advancedFilter.id, advancedFilter.name, advancedFilter)">
          </pdq-icon>
          <pdq-icon icon="edit-1" class="edit" (click)="onLoadAdvancedFilter($event, advancedFilter, true)"> </pdq-icon>
          <pdq-icon icon="pin" size="large" (click)="onUnPinnedRow($event, advancedFilter)"> </pdq-icon>
        </div>
        @if (showIndex === advancedFilter.id) {
        <section>
          <div class="duplicate-filter-section">
            <div class="duplicate-filter-section__text">
              @for (info of expandFilterInfo; track info) {
              <div>{{info}}</div>
              }
            </div>
            <div class="duplicate-filter">
              <a
                (click)="onLoadAdvancedFilter($event, advancedFilter, false);onExpandRow($event,advancedFilter.id, advancedFilter)"
                >Duplicate Filter</a
              >
            </div>
          </div>
        </section>
        }
      </mat-button-toggle>
      } @if (pinnedArray?.length > 0) {
      <div style="border-bottom: 1px solid #d8d8e1; margin: 15px 0 20px 0; width: 100%"></div>
      } @for (advancedFilter of regularAdvancedFilterArray; track identify(j, advancedFilter); let j = $index) {
      <mat-button-toggle
        [cdkDragData]="advancedFilter"
        cdkDrag
        class="advanced-filters-manage__group-button"
        [value]="advancedFilter">
        <div class="filter-item">
          <div cdkDragHandle class="drag-wrapper">
            @for (i of [0, 1, 2, 3, 4, 5]; track $index) {
            <div class="drag-rectangle"></div>
            }
          </div>
          <button
            class="manage-filters__button-icon expand-icon"
            id="selected"
            (click)="onExpandRow($event,advancedFilter.id, advancedFilter)">
            <img src="assets/icons/expand-arrow.svg" [ngClass]="{'rotate': showIndex === advancedFilter.id}" />
          </button>
          <span class="manage-filters__button-name">
            {{ advancedFilter.name }} @if (advancedFilter.resultCount) {
            <span>({{ advancedFilter.resultCount }})</span>
            }
          </span>
          <pdq-icon
            icon="delete"
            (click)="onDeleteFilter($event, advancedFilter.id, advancedFilter.name, advancedFilter)">
          </pdq-icon>
          <pdq-icon icon="edit-1" class="edit" (click)="onLoadAdvancedFilter($event, advancedFilter, true)"> </pdq-icon>
          <pdq-icon icon="pin" size="large" class="un-pin" (click)="onPinnedRow($event, advancedFilter)"> </pdq-icon>
        </div>
        @if (showIndex === advancedFilter.id) {
        <section>
          <div class="duplicate-filter-section">
            <div class="duplicate-filter-section__text">
              @for (info of expandFilterInfo; track info) {
              <div>{{info}}</div>
              }
            </div>
            <div class="duplicate-filter">
              <a
                (click)="onLoadAdvancedFilter($event, advancedFilter, false);onExpandRow($event,advancedFilter.id, advancedFilter)"
                >Duplicate Filter</a
              >
            </div>
          </div>
        </section>
        }
      </mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>
</div>
}
